import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { RouteState } from '../model/enums/route-state';
import { ContextService } from './context.service';

@Injectable()
export class RoutingService
{
    private readonly contextService: ContextService;
    private currentRoute = '/';
    private router: Router;
    private routeChangeSubscription: Subscription;
    private routeState: RouteState;

    @Inject(DOCUMENT) private documentService: Document;  

    public constructor(
        contextService: ContextService,
        router: Router
    )
    {
        this.contextService = contextService;
        this.router = router;

        this.setInitialRoute();
    }

    private setInitialRoute(): void
    {
        this.currentRoute = window.location.pathname;
        this.setRouteState(this.currentRoute);
    }

    private getRoute(): string
    {
        return this.currentRoute;
    }

    public navigateMyPage(): void
    {
        this.documentService.location.href = '/min-side';
    }

    public getRouteState(): RouteState
    {
        return this.routeState;
    }

    public subscribeRouteState(): void
    {
        this.routeChangeSubscription = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)).
            subscribe(val =>
            {
                const route = (val as any).urlAfterRedirects as string;
                this.setRouteState(route);
            });
    }

    public setRouteState(route: string): void
    {
        if (route.startsWith('/shop') && !route.endsWith('/kvittering'))
        {
            this.routeState = RouteState.checkout;
        }
        else if (route.startsWith('/lodder-til-salg'))
        {
            this.routeState = RouteState.shopping;
        }
        else
        {
            this.routeState = RouteState.other;
        }
    }

    public getRequestQuery(): string
    {
        const parameters = Array.from(this.contextService.request.parameters.entries());
        if (parameters.length > 0)
        {
            return parameters.reduce<string[]>((acc: string[], keyValue: string[]) =>
            {
                acc.push(`${keyValue[0]}=${keyValue[1]}`);
                return acc;
            }, []).join('&');
        }

        return '';
    }
}
